/**
 * CSS o'zgaruvchisi ishlamaydigan yagona joy.
 *
 * Telegram'ning `setHeaderColor` / `setBackgroundColor` API'lari hex STRING
 * qabul qiladi — `var(--bg)` ni tushunmaydi. Shuning uchun bu qiymat ikki
 * joyda yashashga majbur: `colors.css` dagi `--bg` va shu yerda.
 *
 * Ikkalasi mos bo'lishi SHART. O'zgartirsangiz — ikkalasini.
 */
export const THEME_BG = '#07070D';
